import React, { Component, Fragment } from 'react';
import withLocalizeAwareIframe from 'pages/utils/withLocalizeAwareIframe';
import withRouteAwareIframe from 'pages/utils/withRouteAwareIframe';
import withValidSessionIframe from 'pages/utils/withValidSessionIframe';
import { path } from './routes';

class SubscriptionsIframe extends Component {
  shouldComponentUpdate() {
    return false;
  }

  render() {
    const segment = window.location.pathname.replace(path, '');
    return (
      <Fragment>
        <style
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: `.react-page { height: 100% }`,
          }}
        />
        <iframe
          title="subscriptions"
          src={`/webapps_redirect.php?app=subscriptions-service&next=${encodeURIComponent(
            segment
          )}`}
          style={{ border: 'none', width: '100%', height: '100%', display: 'block' }}
        />
      </Fragment>
    );
  }
}

export default withLocalizeAwareIframe(
  withRouteAwareIframe(withValidSessionIframe(SubscriptionsIframe))
);
